import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import * as $ from 'jquery';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http'
import { Router } from "@angular/router";
import { AuthService } from '../../../_services';
import { AccessConfig, ParameterData } from '../../../_helpers';

@Component({
  selector: 'app-old-snav-menu',
  templateUrl: './old-snav-menu.component.html'
})

export class OldSnavMenuComponent implements OnInit, OnDestroy {

  @Input() version: string = '';
  profile: any;
  isLoggedin: any;
  isReloaded: any;
  profilePicture: any;
  profileName: any;
  accessToken: any;

  dataAccessList: any;
  fdataAccessList: any;
  isLoading: any;
  public html: SafeHtml;


  constructor(
    private http: HttpClient
    , private router: Router
    , private authService: AuthService
    , private accessConfig: AccessConfig
    , private parameterData: ParameterData
    , private sanitizer: DomSanitizer
  ) {
    this.isLoggedin = false;
    this.profilePicture = '';
    this.profileName = '';
    this.isLoading = false;
    this.html = sanitizer.bypassSecurityTrustHtml(localStorage.getItem("accessmenu"));
    this.dataAccessList = localStorage.getItem("accessmenu");
  }

  getRoute(event) {
    const goRoute = event.target.getAttribute('routerLink')
    if (goRoute != null && goRoute !== '#') {
      this.router.navigate([goRoute]);
    }
  }

  getSafeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    $.getScript("../../assets/js/common.js", function () {
    });

    if (this.authService.isAuthenticated()) {
      this.isLoggedin = true;
      this.accessToken = localStorage.getItem('access_token');
      this.profilePicture = localStorage.getItem('userPhoto');
      this.profileName = localStorage.getItem("username");
      this.dataAccessList = localStorage.getItem("accessmenu");
    }
  }

  GetAccessConfigDetails() {}

  GetAccessDashBoardDetails(value) {
    return true;
  }

  ngOnDestroy() {
    // handle the case where we don't detect the browser
    $.getScript("../../assets/js/common.js", function () {
    });
  }

}
